import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExpressService } from '../services/express.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-express-request',
  templateUrl: './express-request.component.html',
  styleUrls: ['./express-request.component.scss']
})
export class ExpressRequestComponent implements OnInit, OnDestroy {
  public accessRoles: any;
  public uuid:string='';

  public selectedGender = "Both";
  public isResetForm = false;
  public quoteObj:any = [];
  public quoteObjSection:any = {};
  public previousRequest="";
  constructor(
    public expressService: ExpressService,
    public sanitization: DomSanitizer,
    private notifier:NotifierService,
    private router: Router,
    private activaterRoute:ActivatedRoute
  ) { 
     this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    this.expressService.expressSaveId = this.uuid;
     this.expressService.updateRelatedFieldEmitter
      .subscribe((data: any) => {
        this.updateRelatedFields(data);
      })
      this.expressService.isExpressFormReloadEmitter
      .subscribe((data) => {
        if(this.uuid === data.uuid){
          this.getForm();
        }
      })
  }

  ngOnInit(): void {
    this.expressService.isSearchShow = false;
    this.expressService.expressSaveId = this.uuid;
    this.getForm();
  }

  ngOnDestroy(): void {
    this.expressService.eid = "";
    this.expressService.expressSaveId = "";
    this.expressService.expressUUid = "";
    this.expressService.savePayloadObject = {};
    this.expressService.savePrevPayloadObject = "";
  }

  getForm() {
    let query = this.uuid && this.uuid != "" ?{"uuid":this.uuid} : {};
    this.expressService.getForm(query).subscribe((result) => {
      if (result["status"] == 1) {
        this.quoteObj = result['data'];
        if (this.uuid && this.uuid != '' && !this.isResetForm) {
          this.getQuoteDetails();
        }else{
          this.isResetForm = false;
          this.quoteObjSection = {};
          this.initQuoteObj();
        }
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }

  getQuoteDetails() {
    this.expressService.getQuoteData(this.uuid).subscribe((result) => {
      if (result["status"] == 1) {
        let data = result['data'];
        this.expressService.eid = result["eid"];
        this.reAssignQuoteObj(data); 
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })

  }

  initQuoteObj(){
    this.expressService.showDataSaving = false;
    this.quoteObj.forEach((field,index) => {
      this.quoteObjSection[field.group_label] = this.quoteObjSection[field.group_label] ? this.quoteObjSection[field.group_label] : {'values':[]};
      this.quoteObjSection[field.group_label]["show"] = field.group_label == 'Basic Details' ? true : true;
      // this.quoteObjSection[field.group_label]["show"] = field.group_label == 'Basic Details' ? true : false;
      field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? field["selectedValue"] : field["selectedValue"] >= 0 ? field["selectedValue"] : "";
      if (field["type"] == 'from-to') {
        field["selectedValue"] = {from:"",to:""};
        // field["selectedValue"] = {from:field["value"]["from"],to:field["value"]["to"]};
      }else if (field["type"] == 'percent-term') {
        field["selectedValue"] = [{"percent":"","term":""}];
        // field["selectedValue"] = {"percent":field["value"][0]["percent"],"term":field["value"][0]["term"]};
      }else if (field["type"] == 'single-select' && field["disabled"]) {
        let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
        field["selectedValue"] = option && option["label"] ? option["label"] : "";
      }

      if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
       field["filteredValue"] = JSON.parse(JSON.stringify(field["value"])) ;
      }
      
      this.quoteObjSection[field.group_label]["values"].push(field);
    });
    // console.log(this.quoteObjSection);
    // this.onDependencyChangeInInterlokingQuota();
  }


  reAssignQuoteObj(data){
    this.expressService.showDataSaving = true;
    let quoteObjSectionCopy = {}
    let dependentFieldCheck = [];
    
    this.expressService.savePayloadObject = {};
    this.quoteObj.forEach((field,index) => {
      quoteObjSectionCopy[field.group_label] = (quoteObjSectionCopy && quoteObjSectionCopy[field.group_label]) ? quoteObjSectionCopy[field.group_label] : {"values": []};
      quoteObjSectionCopy[field.group_label]["show"] = true;
      this.expressService.savePrevPayloadObject = JSON.stringify(data);
      if (Object.keys(data).includes(field["id"] +'')) {

        field["selectedValue"] = data[field["id"]]["value"];
        if (field["type"] == 'from-to') {
          field["selectedValue"] = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) : field["selectedValue"];
        }else if (field["type"] == 'percent-term') {
          field["selectedValue"] = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) : [{"percent":"","term":""}];
        }else if (field["type"] == 'single-select-obj') {
          let selectedValue = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) :field["selectedValue"];
          field["selectedValue"] = (selectedValue && selectedValue !="") ? selectedValue["label"] :"";
        }else if (field["type"] == 'multi-select-obj') {
          let selectedValue = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) :field["selectedValue"];
          field["selectedValue"] = (selectedValue && selectedValue !="") ? selectedValue.map(item => {return item.id}) :"";
        }else if (field["type"] == 'multi-select') {
          field["selectedValue"] = (field["selectedValue"] && field["selectedValue"] !="" && typeof field["selectedValue"] === 'string') ? JSON.parse(field["selectedValue"]) :field["selectedValue"];
        }

        if (field["dependent"] && field["dependent"]["to"] || (field["key"]=="gender" && field["selaectedValue"] != "")) {
          dependentFieldCheck.push(field);
        }
        if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
          field["filteredValue"] = JSON.parse(JSON.stringify(field["value"])) ;
         }
      }else{
        field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? field["selectedValue"] : "";
        if (field["type"] == 'from-to') {
          field["selectedValue"] = {from:"",to:""};
        }else if (field["type"] == 'percent-term') {
          field["selectedValue"] = [{"percent":"","term":""}];
        }else if (field["type"] == 'single-select' && field["disabled"]) {
          let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
          field["selectedValue"] = option && option["label"] ? option["label"] : "";
          this.expressService.savePayloadObject[field.id] = option && option["label"] ? option["label"] : "";
        }
        if (field["type"] == 'single-select' || field["type"] == 'multi-select' || field["type"] == 'single-select-obj' || field["type"] == 'multi-select-obj') {
          field["filteredValue"] = JSON.parse(JSON.stringify(field["value"])) ;
         }

      }
      quoteObjSectionCopy[field.group_label]["values"].push(field);
    });
    this.quoteObjSection = JSON.parse(JSON.stringify(quoteObjSectionCopy));
    // console.log("dependentFieldCheck ====>",dependentFieldCheck);
    dependentFieldCheck.forEach((field) => {
      if (field.type == 'radio') {
        this.onRadioChange(field,true);
      }else{
        this.checkOtherDependent(field,true);
      }
    })
    this.setGernalAutoSaveOn();
  }

   checkSection(){
    if (this.quoteObjSection && Object.keys(this.quoteObjSection).length) {
      return true;
    }else{
      return false;
    }
  }

  onRadioChange(field, isReassign?:boolean){
    if(this.validateField(field)){
      let dependent = field.dependent ? field.dependent : null;
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to,field.id,field.selectedValue);
      }
      if (isReassign) {
        // this.appendToQuoteObjPayload(field, true);
      }else{
        this.appendToQuoteObjPayload(field);
      }
    }
  }

  checkOtherDependent(field, isReassign?:boolean){
      let dependent = field.dependent ? field.dependent : null;
      if (dependent && dependent.to) {
        this.checkDependent(dependent.to,field.id,field.selectedValue);
      }
      if (isReassign) {
        // this.appendToQuoteObjPayload(field, true);
      }else{
        this.appendToQuoteObjPayload(field);
      }
  }

   onInputFiledFocusOut(field:any){
    let value = field.selectedValue + "";
    if(this.validateField(field)){
      if(value == '' && field.required){
        this.notifier.notify('error',field.label + ' is required !');
      }else{
        this.appendToQuoteObjPayload(field);
      }
    }
  }

  onPercentTermFocusOut(field:any,rIndex){
    if(this.validateField(field)){
      let id = field.id+"";
      if (field && field.selectedValue  && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
        this.expressService.savePayloadObject[id] = [];
        this.expressService.savePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

  }

  onSelectChangePercentTerm(field,option,rIndex){
    if(this.validateField(field)){
      let id = field.id+"";
      if (field && field.selectedValue  && field.selectedValue[rIndex] && field.selectedValue[rIndex].percent != "" && field.selectedValue[rIndex].term != "") {
        this.expressService.savePayloadObject[id] = [];
        this.expressService.savePayloadObject[id] = JSON.parse(JSON.stringify(field.selectedValue));
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

  }

  onSelectChange(selectCtrl:MatSelect,field:any){
      if(this.validateField(field)){
        if (field && field.misc && field.misc.form_reload) {
          this.expressService.isFormReload = true;
        }
        this.appendToQuoteObjPayload(field);
      }
    }

    onObjSelectChange(selectedObjOption,field:any){
      if(this.validateField(field)){
        let id = field.id+"";
        if(!this.expressService.savePayloadObject[id]){
          this.expressService.savePayloadObject[id] = {};
        }else{
          this.expressService.savePayloadObject[id] = typeof this.expressService.savePayloadObject[id]  === 'string' ? JSON.parse(this.expressService.savePayloadObject[id]) : this.expressService.savePayloadObject[id];
        }
        this.expressService.savePayloadObject[id]["label"] = selectedObjOption.value.label;
        this.expressService.savePayloadObject[id]["id"] = selectedObjOption.key;
        if (field && field.misc && field.misc.form_reload) {
          this.expressService.isFormReload = true;
        }
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

    onMultiObjSelectChange(field:any){
      if(this.validateField(field)){
        let id = field.id+"";
        if(id && id == "27"){
          if (field.selectedValue && field.selectedValue.length > 1 && field.selectedValue.includes('pan')) {
            field.selectedValue = ['pan'];
            this.notifier.notify('warning','Can not select any center if Pan India is selected !');
            // return;
          }
        }
        this.expressService.savePayloadObject[id] = [];
        field.selectedValue.forEach((selectedKey) => {
          this.expressService.savePayloadObject[id].push({"id":selectedKey,"label":field.value[selectedKey].label});
        })      
        if (field && field.misc && field.misc.form_reload) {
          this.expressService.isFormReload = true;
        }
        if (field && field.misc && field.misc.form_reload) {
          this.expressService.isFormReload = true;
        }
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }

    onToggleChange(field){
      if(this.validateField(field)){
        
        let id = field.id+"";
        this.expressService.savePayloadObject[id] = field.selectedValue;
        if (field && field.misc && field.misc.auto_save) {
          this.isAnyChangeInContractSaveQuotePayload();
        }
      }
    }
     isAnyChangeInContractSaveQuotePayload(){
    // this.removeBlankIDs();
      let currentPayload = this.expressService.savePayloadObject;
        if(!this.expressService.savePrevPayloadObject){
          this.expressService.savePrevPayloadObject = JSON.stringify(currentPayload);
          this.expressService.saveExpressQuotePayload();
        }else{
          if (JSON.stringify(currentPayload) != this.expressService.savePrevPayloadObject) {
            this.expressService.savePrevPayloadObject = JSON.stringify(currentPayload);
            this.expressService.saveExpressQuotePayload();
          }
        }
      
      }

    toggleDropdown(index: number, select: MatSelect) {
      if (select.panelOpen) {
        select.close();
      } else {
        select.open();
      }
    }

    updateRelatedFields(data: any) {
      Object.keys(this.quoteObjSection).forEach((groupKey) => {
        this.quoteObjSection[groupKey]['values'].forEach((fieldObj) => {
          if(Object.keys(data).includes(fieldObj['id'] +'')){
            fieldObj['selectedValue'] = data[fieldObj['id']]['value'];
            let isValid = this.validateField(fieldObj);
          }
        })
      })
    }

    getGridStyle(type: string, field?:any) {
      if (type === 'grid') { // condition for the item to span both columns
        return { 'grid-column': 'span 2' };
      }
      if (field && field.misc && field.misc.span) {
        let spanObj = {}
        if (field.misc.span.column) {
          spanObj['grid-column'] = 'span ' + field.misc.span.column;
        }
        if (field.misc.span.row) {
          spanObj['grid-row'] = 'span ' + field.misc.span.row;
        }
        return spanObj;
      }
      return {};
    }






  appendToQuoteObjPayload(field, isReassign?:boolean){
    let id = field.id+"";

    this.expressService.savePayloadObject[id] = field.selectedValue;
    if (field && field.misc && field.misc.auto_save && !isReassign) {
      this.isAnyChangeInContractSaveQuotePayload();
    }
    
  }

  checkDependent(fields,currentFieldId,selectedValue){
    if(fields && fields.length){
      fields.forEach(field => {
        let dependentToField = this.quoteObj.find((item) => item.id == field.id);
        if (field.value.includes(selectedValue)) {
          Object.keys(field).forEach((fKey) => {
            if(fKey != "id" && fKey != "value") {
              dependentToField[fKey] = field[fKey];
            }
          })
        }
        this.quoteObjSection[dependentToField.group_label]["values"].forEach((fItem) => {
          if(fItem.id == field.id){
            Object.keys(field).forEach((fKey) => {
              if(fKey != "id" && fKey != "value") {
                fItem[fKey] = dependentToField[fKey];
              }
            })
          }
        })
      });
    }
  }

  setGernalAutoSaveOn(){}

  //  validateField(field:any){
  //   if (field && field.validation && field.validation.length) {
  //     let isValid = true;
  //     if (field && field.required && field.selectedValue == "") {
  //       this.notifier.notify('error',field.label + ' is required !');
  //       isValid = false;
  //       field['error'] = true;
  //       return isValid;
  //     }
  //     field.validation.forEach((validation) => {
  //       if (validation.type == "regex") {
  //         const regex = new RegExp(validation.value);
  //         isValid = regex.test(field.selectedValue);
  //         if (!isValid) {
  //           this.notifier.notify('error',validation.message);
  //           isValid = false;
  //           return isValid;
  //         }
  //       }else if (validation.type == "total-invoicing-sum") {
  //         let totalInvoicing = 0;
  //         field.selectedValue.forEach((item) => {
  //           totalInvoicing += item.percent ? parseInt(item.percent) : 0;
  //         });
  //         if (totalInvoicing > validation.value) {
  //           this.notifier.notify('error',validation.message);
  //           isValid = false;
  //           return isValid;
  //         }
  //       }else if (validation.type == "age-range") {
  //         if (field.selectedValue["from"] && field.selectedValue["from"] != "" && field.selectedValue["to"] && field.selectedValue["to"] != "") {
  //           if (!(parseInt(field.selectedValue["from"]) <= parseInt(field.selectedValue["to"]))) {
  //             isValid = false;
  //             this.notifier.notify('error',validation.message);
  //             return isValid;
  //           }
  //         }

  //       }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
  //         let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
  //         if (selectedValue > validation.value) {
  //           this.notifier.notify('error',validation.message);
  //           isValid = false;
  //           return isValid;
  //         }
  //       }
  //     });
  //     if(!isValid){
  //       field['error'] = true;
  //     }else{  
  //       field['error'] = false;
  //     }
  //     return isValid;
  //   }else{
  //     field['error'] = false;
  //     return true;
  //   }
  // }

  // validateFullForm(){
    
  //   let isFormValid = true;
  //   // console.log("this.quoteObjSection ====>",this.quoteObjSection);
  //   for(const sectionKey in this.quoteObjSection){
  //     for(const field of this.quoteObjSection[sectionKey]["values"]){

  //       if (field && field.required  && field.show && !field.disabled && (field.selectedValue == "" || field.selectedValue.from == "" || field.selectedValue.to == "")) {
  //         let isValid = true;
  //         if (field.type == 'from-to') {
  //           if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
  //             isValid = false;
  //           }
  //         }else if (field.type == 'percent-term') {
  //           if (field.selectedValue && field.selectedValue.length < 2 && field.selectedValue[0]["percent"] == "") {
  //             isValid = false;
  //           }
  //         }else{
  //           if(field.selectedValue == ""){
  //             isValid = false;
  //           }
  //         }
  //         if(!isValid){
  //           field['error'] = true;
  //           this.notifier.notify('error',field.label + ' is required !');
  //           isFormValid = false;
  //           break;
  //         }else{
  //           field['error'] = false;
  //         }
  //       }
  //       if (field && field.validation && field.validation.length) {
  //         let isValid = true;
  //         if (!field.required  && field.selectedValue == "") {
  //           isValid = true;
  //         }else{
  //           field.validation.forEach((validation) => {
  //             if (validation.type == "regex") {
  //               const regex = new RegExp(validation.value);
  //               isValid = regex.test(field.selectedValue);
  //               if (!isValid) {
  //                 this.notifier.notify('error',validation.message);
  //                 isValid = false;
  //                 // return isValid;
  //               }
  //             }else if (validation.type == "total-invoicing-sum") {
  //               let totalInvoicing = 0;
  //               field.selectedValue.forEach((item) => {
  //                 totalInvoicing += item.percent ? parseInt(item.percent) : 0;
  //               });
  //               if (totalInvoicing > validation.value) {
  //                 this.notifier.notify('error',validation.message);
  //                 isValid = false;
  //                 // return isValid;
  //               }
  //             }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
  //               let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
  //               if (selectedValue > validation.value) {
  //                 this.notifier.notify('error',validation.message);
  //                 isValid = false;
  //                 // return isValid;
  //               }
  //             }
  //           });
  //         }
  //         if(!isValid){
  //           field['error'] = true;
  //           isFormValid = false;
  //           break;
  //         }else{
  //           field['error'] = false;
  //         }
  //         // return isValid;
  //       }
  //     }
  //     if(!isFormValid){
  //       break;
  //     }
  //   }
  //   // console.log("quoteObjSection ====>",this.quoteObjSection);
  //   return isFormValid;
  // }

    validateField(field:any){
    let isValid = true;

    if (field && field.required && field.show && !field.disabled) {
          if (field.type == 'from-to') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          }else if (field.type == 'percent-term') {
            if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item =>{ return item.percent == "" || item.term == ""})) {
              isValid = false;
            }
            // if (field.selectedValue && (field.selectedValue.length < 1 || field.selectedValue[0]["percent"] == "" || field.selectedValue[0]["term"] == "")) {
            //   isValid = false;
            // }
          }else{
            if(field.selectedValue == ""){
              isValid = false;
            }
          }
          if(!isValid){
            field['error'] = true;
            this.notifier.notify('error',field.label + ' is required !');
            return isValid;
          }else{
            field['error'] = false;
          }
        }
    if (field && field.show && field.validation && field.validation.length) {
      field.validation.forEach((validation) => {
        if (validation.type == "regex") {

          if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
            const regex = new RegExp(validation.value);
            isValid = regex.test(field.selectedValue);
            if (!isValid) {
              this.notifier.notify('error',validation.message);
              isValid = false;
              return isValid;
            }
          }
        }else if (validation.type == "total-invoicing-sum") {
          let totalInvoicing = 0;
          field.selectedValue.forEach((item) => {
            totalInvoicing += item.percent ? parseInt(item.percent) : 0;
          });
          if (totalInvoicing != validation.value) {
            this.notifier.notify('error',validation.message);
            isValid = false;
            return isValid;
          }
        }else if (validation.type == "age-range") {
          if (field.selectedValue["from"] && field.selectedValue["from"] != "" && field.selectedValue["to"] && field.selectedValue["to"] != "") {
            if (!(parseInt(field.selectedValue["from"]) <= parseInt(field.selectedValue["to"]))) {
              isValid = false;
              this.notifier.notify('error',validation.message);
              return isValid;
            }
          }

        }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
          let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
          if (selectedValue > validation.value) {
            this.notifier.notify('error',validation.message);
            isValid = false;
            return isValid;
          }
        }
      });
      if(!isValid){
        field['error'] = true;
      }else{  
        field['error'] = false;
      }
      return isValid;
    }else{
      field['error'] = false;
      return true;
    }
  }

  validateFullForm(){
    let isFormValid = true;
    // console.log("this.quoteObjSection ====>",this.quoteObjSection);
    for(const sectionKey in this.quoteObjSection){
      for(const field of this.quoteObjSection[sectionKey]["values"]){

        if (field && field.required && this.quoteObjSection[sectionKey].show && field.show && !field.disabled) {
          let isValid = true;
          if (field.type == 'from-to') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          }else if (field.type == 'percent-term') {
            if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item =>{ return item.percent == "" || item.term == ""})) {
              isValid = false;
            }
            // if (field.selectedValue && field.selectedValue.length < 2 && field.selectedValue[0]["percent"] == "") {
            //   isValid = false;
            // }
          }else{
            if(field.selectedValue == ""){
              isValid = false;
            }
          }
          if(!isValid){
            field['error'] = true;
            // console.log("field.label ====>",field);
            this.notifier.notify('error',field.label + ' is required !');
            isFormValid = false;
            break;
          }else{
            field['error'] = false;
          }
        }
        if (field && this.quoteObjSection[sectionKey].show && field.show && field.validation && field.validation.length) {
          let isValid = true;
          if (!field.required  && field.selectedValue == "") {
            isValid = true;
          }else{
            field.validation.forEach((validation) => {
              if (validation.type == "regex") {
                if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
                  const regex = new RegExp(validation.value);
                  isValid = regex.test(field.selectedValue);
                  if (!isValid) {
                    this.notifier.notify('error',validation.message);
                    isValid = false;
                    // return isValid;
                  }
                }
              }else if (validation.type == "total-invoicing-sum") {
                let totalInvoicing = 0;
                field.selectedValue.forEach((item) => {
                  totalInvoicing += item.percent ? parseInt(item.percent) : 0;
                });
                if (totalInvoicing != validation.value) {
                  this.notifier.notify('error',validation.message);
                  isValid = false;
                  // return isValid;
                }
              }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
                let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
                if (selectedValue > validation.value) {
                  this.notifier.notify('error',validation.message);
                  isValid = false;
                  // return isValid;
                }
              }
            });
          }
          if(!isValid){
            field['error'] = true;
            isFormValid = false;
            break;
          }else{
            field['error'] = false;
          }
          // return isValid;
        }
      }
      if(!isFormValid){
        break;
      }
    }
    // console.log("quoteObjSection ====>",this.quoteObjSection);
    return isFormValid;
  }

  ondropdownSearchChange(searchValue: string, field: any) {
    // searchValue.toLowerCase()
    if (searchValue && searchValue != '') {      
      let allvalue = JSON.parse(JSON.stringify(field["value"])) ;
      field["filteredValue"] = {};
      for (const key in allvalue) {
        const tempObj = allvalue[key];
        if (tempObj.label.toLowerCase().includes(searchValue.toLowerCase()) || tempObj.label.toLowerCase() == "other") {
          field["filteredValue"][key] = tempObj;
        }
      }
    }else{
      field["filteredValue"] = JSON.parse(JSON.stringify(field["value"]));
      // field["value"] = JSON.parse(JSON.stringify(field["allValue"]));
    }

  }

  onSubmit(){
    // console.log("this.expressService.savePayloadObject ====>",this.expressService.savePayloadObject);
    if (this.validateFullForm()) {
      this.expressService.sendExpress(this.uuid)
    }
  }

  onCancel(){
    this.router.navigate(['/express']);
  }
  backToExpressList(){
    this.router.navigate(['/express']);
  }
}
